import { Link } from "react-router-dom";

/* Subtle "Powered by Lumetier" attribution shown on client-facing surfaces
   (public gallery, contract signing, review form). The goal is word-of-mouth
   without competing with the photographer's brand — small, restrained,
   easy to miss if you're focused, easy to click if you're curious.

   `variant`:
     - "light" (default) — for the cream client gallery / review pages
     - "contract"        — slightly darker palette for the contract signing surface

   Links to /lumetier so it resolves on any host (Allure brand, preview, or
   lumetiercreatives.com), and renders in a new tab so the client doesn't
   lose their gallery / contract context. */
export default function PoweredByLumetier({
  variant = "light",
  className = "",
  testid = "powered-by-lumetier",
}) {
  const tones = {
    light: "text-stone-400 hover:text-stone-700",
    contract: "text-muted-foreground hover:text-foreground",
  };
  const tone = tones[variant] || tones.light;

  return (
    <div
      className={`flex items-center justify-center py-8 ${className}`}
      data-testid={testid}
    >
      <Link
        to="/lumetier"
        target="_blank"
        rel="noopener noreferrer"
        className={`inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.32em] transition-colors ${tone}`}
        data-testid={`${testid}-link`}
      >
        <span>Powered by</span>
        <span
          className="font-serif font-light"
          style={{ letterSpacing: "0.28em", fontSize: "12px" }}
        >
          LUMETIER
        </span>
      </Link>
    </div>
  );
}
